import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Icon from '../../components/AppIcon';
import OfferCalculator from './components/OfferCalculator';
import StrategySelector from './components/StrategySelector';
import CostBreakdown from './components/CostBreakdown';

const mockUser = { id: 1, name: 'Sarah Mitchell', email: 'sarah@email.com', role: 'user' };

const OfferRangeGuidance = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <Header user={mockUser} onLogout={() => navigate('/authentication')} />
      <main className="pt-16">
        <div className="max-w-6xl mx-auto px-4 md:px-6 py-8 md:py-12">
          <div className="mb-8">
            <button onClick={() => navigate('/')} className="flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors mb-4 text-sm">
              <Icon name="ArrowLeft" size={16} color="currentColor" />
              Back to Home
            </button>
            <div className="flex items-center gap-3 mb-2">
              <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: 'rgba(0,255,136,0.15)', border: '1px solid rgba(0,255,136,0.3)' }}>
                <Icon name="TrendingUp" size={20} color="#00FF88" />
              </div>
              <h1 className="text-2xl md:text-3xl font-bold text-foreground">Offer Range Guidance</h1>
            </div>
            <p className="text-muted-foreground">Get AI-powered offer recommendations with interactive calculators and negotiation strategy tools.</p>
          </div>

          <div className="bg-green-500/5 border border-green-500/20 rounded-xl p-4 mb-6 flex items-center gap-3">
            <Icon name="Info" size={18} color="#00FF88" />
            <div>
              <p className="text-sm font-medium text-foreground">Sample: 42 Harbour View Terrace, Mosman NSW 2088</p>
              <p className="text-xs text-muted-foreground">Listing price: $2,800,000 — Recommended range: $2,590,000 – $2,800,000</p>
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
            {[
              { label: 'Min Offer', value: '$2.59M', color: '#00D4FF', icon: 'ArrowDownCircle' },
              { label: 'Max Offer', value: '$2.80M', color: '#00FF88', icon: 'ArrowUpCircle' },
              { label: 'Sweet Spot', value: '$2.72M', color: '#FFAA00', icon: 'Target' },
              { label: 'Saving vs Ask', value: '$80K', color: '#AA88FF', icon: 'PiggyBank' },
            ]?.map((m, i) => (
              <div key={i} className="bg-card rounded-xl border border-border p-4">
                <div className="flex items-center gap-2 mb-2">
                  <Icon name={m?.icon} size={16} color={m?.color} />
                  <span className="text-xs text-muted-foreground">{m?.label}</span>
                </div>
                <p className="text-xl font-bold" style={{ color: m?.color }}>{m?.value}</p>
              </div>
            ))}
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
            <OfferCalculator listingPrice={2800000} />
            <StrategySelector />
          </div>

          <div className="mb-6">
            <CostBreakdown offerPrice={2720000} />
          </div>

          <div className="bg-card rounded-xl border border-border p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ background: 'rgba(0,212,255,0.15)' }}>
                <Icon name="MessageSquare" size={16} color="#00D4FF" />
              </div>
              <h3 className="text-lg font-semibold text-foreground">Negotiation Tips</h3>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {[
                { tip: 'Start below your maximum', detail: 'Open at $2,590,000 to leave room to negotiate up to your true limit.' },
                { tip: 'Use the DOM as leverage', detail: '47 days on market gives you negotiating power — mention it casually.' },
                { tip: 'Request vendor disclosure', detail: 'Ask for building inspection, pest report, and strata documents upfront.' },
                { tip: 'Set a deadline', detail: 'Create urgency with a 48-hour offer expiry to prompt a decision.' },
              ]?.map((t, i) => (
                <div key={i} className="p-4 rounded-lg bg-muted/30 border border-border/50">
                  <p className="font-medium text-foreground text-sm mb-1">{t?.tip}</p>
                  <p className="text-xs text-muted-foreground">{t?.detail}</p>
                </div>
              ))}
            </div>
            <div className="mt-4 flex flex-wrap gap-3">
              <button onClick={() => navigate('/agent-questions')} className="px-4 py-2 rounded-lg text-sm font-medium" style={{ background: 'rgba(0,212,255,0.1)', color: '#00D4FF', border: '1px solid rgba(0,212,255,0.3)' }}>Get Agent Questions →</button>
              <button onClick={() => navigate('/reports')} className="px-4 py-2 rounded-lg text-sm font-medium" style={{ background: 'rgba(170,136,255,0.1)', color: '#AA88FF', border: '1px solid rgba(170,136,255,0.3)' }}>Save to Reports →</button>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default OfferRangeGuidance;
